import { render, staticRenderFns } from "./AIQuestionAnswer.vue?vue&type=template&id=6a92cf58&scoped=true"
import script from "./AIQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./AIQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a92cf58",
  null
  
)

export default component.exports